import React from 'react';
import PuzzleButton from '../../UI/button/PuzzleButton';
import CellAbstract from './CellAbstract';
import { CELL_BUTTON_PROPS } from './Types';

/**
 * Component that should be used inside grid if we want to configure specific column to render <button> HTML tag init
 * */
class CellButton extends CellAbstract<CELL_BUTTON_PROPS, {}> {
  render() {
    const {
      actionBtnSettings,
      dataIndex,
      dataItem,
      field
    } = this.props;
    const value = dataItem[(field || dataIndex)];

    return this.renderCell(
      <PuzzleButton
        {...actionBtnSettings}
        tabIndex={0}
      >
        {value}
      </PuzzleButton>
    );
  }
}

export default CellButton;
